import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSortDown({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M4.67 8.88h6.66c.6 0 .9.72.47 1.14L8.48 13.3a.67.67 0 01-.95 0L4.2 10a.66.66 0 01.47-1.13z"
          fill="#56A"
        />
        <path
          d="M11.8 5.98L8.48 2.7a.67.67 0 00-.95 0L4.2 6a.66.66 0 00.47 1.13h6.66c.6 0 .9-.72.47-1.14z"
          fill="#999"
        />
      </g>
    </svg>
  );
}

SvgSortDown.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSortDown.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSortDown svgRef={ref} {...props} />);
export default ForwardRef;
